import type { ClientEvent } from '@/proto/v2/client_event';
import type { Base } from '@/proto/base';
import type { VideoEventOptionsParams } from '@/config/types';

interface Params {
    currentUrlPackage: Base.UrlPackage;
    referUrlPackage: Base.UrlPackage | undefined;
    options: VideoEventOptionsParams;
}

export default (params: Params): ClientEvent.VideoStatEvent => {
    const { currentUrlPackage, referUrlPackage, options } = params;
    return {
        video_stat_event: {
            ...options,
            url_package: currentUrlPackage,
            refer_url_package: referUrlPackage,
        },
    };
}
